var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueRightDir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.996261596679688,
    height: 12.74289112584128,
    viewBox: "0 0 14.996261596679688 12.74289112584128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "translate(14.996261596679688 12.7425537109375)  rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62 5",
    fillRule: "evenodd",
    style: {
      fill: "#2A82E4"
    },
    opacity: 1,
    d: "M-2.13628 -4.25017L-0.00789261 -6.37857L-6.37185 -12.7425L-8.50024 -10.6141L-2.13628 -4.25017Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62 5",
    fillRule: "evenodd",
    style: {
      fill: "#2A82E4"
    },
    opacity: 1,
    d: "M-3.27626 -4.72852L-3.27626 -7.73852L-14.9963 -7.73852L-14.9963 -4.72852L-3.27626 -4.72852Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62 5",
    fillRule: "evenodd",
    style: {
      fill: "#2A82E4"
    },
    opacity: 1,
    d: "M-6.38642 -1.7643e-05L-0.00124168 -6.38519L-2.12256 -8.50651L-8.50774 -2.12134L-6.38642 -1.7643e-05Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRightDir);
export default __webpack_public_path__ + "static/media/blueRightDir.e1dd6df96287f36e8fb6ef53ea64d723.svg";
export { ForwardRef as ReactComponent };